import { InvestmentStage, type InvestmentStageType } from '@/api/investing/types';

/**
 * Shared by both boards that render investment stages — Gamma's investment
 * pipeline and the entity/investor investing board. Keyed by `InvestmentStage`
 * so a stage added to the pipeline fails the typecheck here instead of reaching
 * a board as raw PascalCase, which is how `PaymentMethodSelected` and
 * `FundsReceived` went unlabelled on the Gamma board.
 */
const INVESTMENT_STAGE_LABELS: Record<InvestmentStageType, string> = {
  [InvestmentStage.LinkClicked]: 'Link clicked',
  [InvestmentStage.DueDiligenceViewed]: 'Due diligence viewed',
  [InvestmentStage.SubscriptionStarted]: 'Subscription started',
  [InvestmentStage.EligibilitySubmitted]: 'Eligibility submitted',
  [InvestmentStage.AgreementSigned]: 'Agreement signed',
  [InvestmentStage.DataSubmissionAcknowledged]: 'Data submission acknowledged',
  [InvestmentStage.PaymentMethodSelected]: 'Payment method selected',
  [InvestmentStage.FundsSent]: 'Funds sent',
  [InvestmentStage.FundsReceived]: 'Funds received',
  [InvestmentStage.Invested]: 'Invested',
  [InvestmentStage.Redeemed]: 'Redeemed',
  [InvestmentStage.Rejected]: 'Rejected',
  [InvestmentStage.NotEligible]: 'Not eligible',
  [InvestmentStage.Expired]: 'Expired',
};

export const getInvestmentStageLabel = (stage: string) =>
  INVESTMENT_STAGE_LABELS[stage as InvestmentStageType] ?? stage;
